var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmoji(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.426181,
    d: "M11.0588 0.953125C5.43968 0.953125 0.886949 5.50586 0.886949 11.125C0.886949 16.7441 5.43968 21.2969 11.0588 21.2969C16.678 21.2969 21.2307 16.7441 21.2307 11.125C21.2307 5.50586 16.678 0.953125 11.0588 0.953125ZM11.0588 19.9844C6.13695 19.9844 2.19945 16.0469 2.19945 11.125C2.19945 6.24414 6.13695 2.26562 11.0588 2.26562C15.9397 2.26562 19.9182 6.24414 19.9182 11.125C19.9182 16.0469 15.9397 19.9844 11.0588 19.9844ZM14.7502 13.9961C13.8069 15.1035 12.4534 15.7188 11.0588 15.7188C9.62328 15.7188 8.26976 15.1035 7.3264 13.9961C7.12132 13.709 6.71117 13.709 6.42406 13.9141C6.13695 14.1602 6.09593 14.5703 6.34203 14.8574C7.49046 16.252 9.21312 17.0312 11.0588 17.0312C12.8635 17.0312 14.5862 16.252 15.7346 14.8574C15.9807 14.5703 15.9397 14.1602 15.6526 13.9141C15.4065 13.709 14.9553 13.709 14.7502 13.9961ZM7.77757 10.4688C8.47484 10.4688 9.09007 9.89453 9.09007 9.15625C9.09007 8.45898 8.47484 7.84375 7.77757 7.84375C7.03929 7.84375 6.46507 8.45898 6.46507 9.15625C6.46507 9.89453 7.03929 10.4688 7.77757 10.4688ZM14.3401 10.4688C15.0373 10.4688 15.6526 9.89453 15.6526 9.15625C15.6526 8.45898 15.0373 7.84375 14.3401 7.84375C13.6018 7.84375 13.0276 8.45898 13.0276 9.15625C13.0276 9.89453 13.6018 10.4688 14.3401 10.4688Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmoji);
export default __webpack_public_path__ + "static/media/Emoji.b8ed0e71e3e51768a8b7ba28181e0dc0.svg";
export { ForwardRef as ReactComponent };